import { c as _taggedTemplateLiteralLoose } from './chunk-eb25cfa0.js';
import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import 'reuse';
import use from './use.js';
import 'react';
import 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import './Box.js';
import '@emotion/is-prop-valid';
import Flex from './Flex.js';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var InlineFlex = styled(Flex)(_templateObject(), theme("InlineFlex"));
var InlineFlex$1 = use(InlineFlex, "div");

export default InlineFlex$1;
